<template>
  <div class="competeCategoryList">
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事类别 -->
        <el-table-column prop="categoryName" :label="$t('lang.lab_competeCategory')" :sortable="'custom'"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="categoryStatus" :label="$t('lang.lab_competeStatus')" :sortable="'custom'">
          <template slot-scope="scope">
            <!-- 0: 禁用 -->
            <span v-if="scope.row.categoryStatus === 0">{{$t('lang.Category_status[1].name')}}</span>
            <!-- 1: 正常 -->
            <span v-if="scope.row.categoryStatus === 1">{{$t('lang.Category_status[2].name')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-suffix=":">
        <!-- 类别 -->
        <el-form-item prop="categoryName" :label="$t('lang.lab_competeCategory')">
          <input style="display: none"/>
          <el-input v-model="form.categoryName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeCategory')" maxlength="20"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item prop="categoryStatus" :label="$t('lang.lab_competeStatus')">
          <el-select v-model="form.categoryStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeStatus')">
            <el-option
              v-for="(item,index) in status"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:competeCategoryList
 *@Description:赛事类别管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 赛事类别管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 赛事类别管理详情(新建编辑)变量 */
      rules: {
        categoryName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeCategory'), trigger: 'blur' }],
        categoryStatus: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeStatus'), trigger: 'change' }],
      },
      status: this.$i18n.t('lang.Category_status'), // 状态下拉list
      form: {
        id: '',
        categoryName: '',
        categoryStatus: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取赛事类别管理列表数据
    getData() {
      this.$get(`/competeCategory/category?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag) { 
      if (flag) {
        this.pageNum = 1
      }
      this.$get(`/competeCategory/category?sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.categoryName = ''
      this.form.categoryStatus = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/competeCategory/category/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.categoryName = data.categoryName
      this.form.categoryStatus = data.categoryStatus
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.isShow = true
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form
          this.$postJson('/competeCategory/category', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.categoryName = ''
      this.form.categoryStatus = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.categoryName = ''
      this.form.categoryStatus = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true)
    },
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
